import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

const PrivateRoute = () => {
  // const isLoggedIn = useSelector((state) => state.auth.authentication);
  const isLoggedIn = localStorage.getItem('token')
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
